import { useSelector } from 'react-redux';

const selectAuth = (state) => ({ isSignedIn: state.unsplash.isSignedIn });
export const useAuth = () => useSelector(selectAuth);

const selectSearchParams = (state) => ({
  searchPhrase: state.unsplash.searchPhrase,
  orderBy: state.unsplash.orderBy,
  slug: state.unsplash.slug,
});
export const useSearchParams = () => useSelector(selectSearchParams);

const selectUI = (state) => ({
  isFiltersPanelOpen: state.unsplash.isFiltersPanelOpen,
  areFiltersSet: state.unsplash.areFiltersSet,
  uploadInProgress: state.unsplash.uploadInProgress,
});
export const useUI = () => useSelector(selectUI);

export const selectHomePageAssets = (state) => ({
  items: state.unsplash.homePageItems,
  assetsInProgress: state.unsplash.list.assetsInProgress,
  selected: state.unsplash.list.selected,
});
export const useHomePageAssets = () => useSelector(selectHomePageAssets);

export const selectAssets = (state) => ({
  items: state.unsplash.list.items,
  assetsInProgress: state.unsplash.list.assetsInProgress,
  page: state.unsplash.list.page,
  hasMoreAssets: state.unsplash.list.hasMoreAssets,
  selected: state.unsplash.list.selected,
});
export const useAssets = () => useSelector(selectAssets);

const selectFilterParams = (state) => ({
  ...state.unsplash.filters,
});
export const useFilterParams = () => useSelector(selectFilterParams);

export const selectSelectedAsset = (state) => ({
  selectedFormat: state.unsplash.selectedFormat,
  selectedAsset:
    state.unsplash.list.items.find((a) => a.id === state.unsplash.list.selected) ??
    state.unsplash.homePageItems.find((a) => a.id === state.unsplash.list.selected),
});

export const useSelectedAsset = () => useSelector(selectSelectedAsset);
